const positions = [
  {
    value: 'Shining Angels',
    label: 'Shining Angels',
  },
  {
    value: 'Cruel Pumas',
    label: 'Cruel Pumas',
  },
  {
    value: 'River City',
    label: 'River City',
  },
  {
    value: 'Mystic Unicorns',
    label: 'Mystic Unicorns',
  },
  {
    value: 'Zenonia Knights',
    label: 'Zenonia Knights',
  },
  {
    value: 'Forest Elves',
    label: 'Forest Elves',
  },{
    value: 'Summoners War',
    label: 'Summoners War',
  },
];

export default positions;
